import React from "react";
import { showToast } from "../../../../components/Toast/Toast";
import { Button } from "../../../../components";
const ToastItems = () => {
  const variants = ["contained", "outlined", "text"];
  const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];
  const types = [
    "primary",
    "success",
    "error",
    "warning",
    "info",
    "black",
    "white",
  ];
  return (
    <div className="flex gap-5 flex-col my-5">
      {types.map((type) => (
        <div className="flex gap-5" key={type}>
          {variants.map((variant) => (
            <Button
              key={`${type}-${variant}`}
              title={`${type}`}
              size="md"
              color={type === "error" ? "danger" : type}
              variant={variant}
              onClick={() =>
                showToast(
                  `${type}`,
                  `${type}`,
                  3000,
                  `${variant}`,
                  "md",
                  type === "error" ? "danger" : type
                )
              }
            />
          ))}
        </div>
      ))}

      {/* <div className="flex flex-col gap-8">
        {colors.map((color) => (
          <div className="flex gap-8">
            {variants.map((variant) => (
              <div className="flex gap-8">
                {types.map((type) => (
                  <Button
                    title={`Badge`}
                    size="sm"
                    color={color}
                    variant={variant}
                    onClick={() =>
                      showToast(
                        `${color}-${variant}-${type}`,
                        `${type}`,
                        3000,
                        `${variant}`,
                        "md",
                        `${color}`
                      )
                    }
                  />
                ))}
              </div>
            ))}
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default ToastItems;
